import styled from 'styled-components';

export const SalesOrderContainer = styled.div`
  gap: 1.5rem;
`;

export const SalesOrderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SalesOrderContainerTitle = styled.h1`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  font-family: 'Source Sans Pro';
  color: ${({ theme }) => theme.colors.grayDark3};
  margin-bottom: 1rem;
`;

export const SalesOrderItemContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};

  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.white};

  box-shadow: 0px 7px 7px -3.5px #18274b14;
  box-shadow: 0px 3.5px 5.25px -3.5px #18274b1f;
  border: solid 1px #dee8ef;

  border-radius: 0.5rem;
`;

export const SalesOrderItemHeader = styled.div<{ resume: boolean }>`
  display: flex;
  justify-content: space-between;
  /* align-items: center; */

  margin-bottom: ${({ resume }) => (resume ? 0 : '2rem')};
`;

export const SalesOrderItemDetail = styled.div`
  display: flex;
  gap: 1.5rem;
  > img {
    border-radius: 10px;
    width: 3rem;
    height: 3rem;
  }
`;

export const SalesOrderItemWrapper = styled.div``;

export const SalesOrderResumeWrapperContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const SalesOrderResumeWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 120px) 1fr;
  grid-template-areas: a b c d e;

  gap: 1rem;
`;

export const SalesOrderItemText = styled.span<{
  bold?: boolean;
  small?: boolean;
  alignRight?: boolean;
}>`
  display: block;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  font-size: ${({ small }) => (small ? '14px' : '1rem')};

  display: flex;
  justify-content: ${({ alignRight }) => (alignRight ? 'end' : 'normal')};
`;

export const SalesOrderTextTooltipWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const SalesOrderContentWrapper = styled.div``;

export const SalesOrderContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.5rem;

  margin-bottom: 1.5rem;
`;
export const SalesOrderDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SalesOrderDetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const SalesOrderActionButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SalesOrderActionButtonsWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
`;

export const MessageValueCanChange = styled.span`
  font-size: 14px;
  font-weight: 400;
  font-family: ${({ theme }) => theme.fonts.workSans};
`;
